import gql from 'graphql-tag';

const NAME = 'compositions_CaseContacts_contactTypesQuery';

export default gql`
  query ${NAME} {
    caseContactTypes {
      default
      option
      text
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseContacts/withContactTypes/contactTypesQuery.js